import {html, css} from 'lit'
import {TBase} from '../../../wcl/base'


export class TTemplateEditView extends TBase 
{
    static styles = [ TBase.styles, css`` ]

    static properties = {
        ...TBase.properies,
        uid : { type: String, attribute: 'data-vx-uid' },
        url : { type: String, attribute: 'data-vx-resource'},
        api : { type: String, attribute: 'data-vx-api'}
    }

    constructor() {
        super()
    }

    render() {
        console.log('rendering template-edit', this.uid)
        var fields = [
            { name: 'uid'                   , type: 'hidden' },
            { name: 'name'                  , type: 'text'       , label: 'Nom',  required: true  },
            { type: 'separator' },
            { name: 'data.caller'           , type: 'text'       , label: 'Numéro appelant'   , prefix: '+', placeholder: "33000000000", pattern: "33[1-9]\\d{8}",  required: true},
            { name: 'data.ring_timeout'     , type: 'number'     , label: 'Durée de sonnerie max (non-réponse)', suffix: 'sec', default: 20,  required: true},
            { name: 'data.sip_headers'      , type: 'textarea'   , label: 'Entête SIP (pour les numéros SIP uniquement)', placeholder: "key1=value1,key2=value2,..."},
            { type: 'separator' },
            { name: 'data.input_type'       , type: 'select'     , label: 'type de saisie'    , actions: ['DTMF', 'Speech'], disabled: true  },
            { name: 'data.input_sequence'   , type: 'text'       , label: 'séquence de saisie', prefix: 'DTMF', disabled: true  },
            { type: 'separator' },
            { name: 'data.speech_detection' , type: 'checkbox'   , label: 'détection de parole', default: true,  required: true},
            { type: 'separator' },
            { name: 'data.transcription'    , type: 'checkbox'   , label: 'Transcription des appels', disabled: true },
        ]
        var buttons = [{label: 'enregistrer', action: 'submit', color: 'primary'}]
        var datasrc = this.url
        var desturl = this.api
        if(this.uid)  buttons.push({label: 'supprimer', action: 'delete', color: 'danger'})

        return html`
            ${super.render()}
            <div class="container-fluid pe-5 mt-5">
            <div class="row"><vx-card>TEMPLATES / EDIT</vx-card></div>
            <div class="row pt-3">
                <vx-card
                    data-vx-header='Edition de fiche utilisateur'>
                    <vx-form
                        name='template'
                        method='POST'
                        url=${desturl}
                        data-vx-datasrc=${datasrc}
                        data-vx-fields=${JSON.stringify(fields)}
                        data-vx-buttons=${JSON.stringify(buttons)}
                    ></vx-form>
                </vx-card
        `
    }
}

if (!customElements.get('vx-template-edit-view')) 
    customElements.define('vx-template-edit-view', TTemplateEditView);

/*
    "uid": "001",
    "firstname": "Ahmed",
    "lastname": "Gabal",
    "email": "a.gabal@me.com",
    "tel": "07 89 77 14 01",
    "templatename": "a.gabal@me.com",
    "password": "****"


    input.id            = input.id || `${input.type}-${uuid()}`
    input.type          = input.type || 'text'
    input.name          = input.name || input.id
    input.label         = input.label || ''
    input.value         = input.value || ''
    input.placeholder   = input.placeholder || input.label
    input.options       = input.options || []
*/